<template>
    <div class="FullLayout">
        <router-view />
    </div>
</template>
